import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { DataService } from '../../../services/data.service';
import { FormService } from '../../../services/form.service';
import { NmDetailPageClass } from '../../../shared/nm-detail-page-class';
import { ApiService } from '../../../services/api.service';

declare let bootbox: any;

@Component({
	selector: 'teacher-detail-page',
	templateUrl: './detail.html',
	styleUrls: ['./detail.css']
})
export class TeachersDetailPage extends NmDetailPageClass {
	public header: string;
	public modelName: string = 'teacher';

	public reloadTable: boolean = false;
	
	public form: FormGroup = this.formBuilder.group({
		// basic information
	  //YFSID: [{value: '', disabled: true}],
		Salutation: [''],
		Name: ['',Validators.required],
	  NameChinese: [''],
	  JobPosition: [''],
		SubjectsTaught: [''],
		Telephone1: [''],
		Telephone2: [''],
		Fax: [''],
		EmailAddress1: [''],
		EmailAddress2: [''],
		InCharge: [''],
		SchoolId: ['',Validators.required]
		
	});

	public onBeforeRendered() {
		/*let control = <FormArray>this.form.get('_contact_channels');
		for(let channel of this.data.shared.communicationChannels.getValue()) {
			control.push(this.formBuilder.control(false));
		}*/

		let map = {
			create: 'Teachers <small><i class="ace-icon fa fa-angle-double-right"></i></small> New Teacher',
			edit: 'Teachers <small><i class="ace-icon fa fa-angle-double-right"></i></small> Edit Teacher',
			view: 'Teachers <small><i class="ace-icon fa fa-angle-double-right"></i></small> View Teacher',
		};
		this.header = map[this.action];

		// TODO: dummy way to fix missing fields
		if(this.action != 'create') {
			//this.form.removeControl('id_document_number');
		}


		//set default value for selection fields
		this.form.controls['Salutation'].setValue('Mr.');
		this.form.controls['InCharge'].setValue('Yes');
	}

	public onBeforeSubmit(data) {
		

		
		 //console.log(data);
		 //return false;
		return data;
	}

	public onBeforePatchValue(data: any): any {
		return new Promise(resolve => {
			// data.InCharge = (data.InCharge ? 'Yes' : 'No');
			// console.log(data);
			resolve(data);

			// Promise.all([
			// 	data.home_address && data.home_address.region_id? this.data.shared.getRegionHierarchyById(data.home_address.region_id): [],
			// 	data.office_address && data.office_address.region_id? this.data.shared.getRegionHierarchyById(data.office_address.region_id): []
			// ]).then(values => {
			// 	data._home_region_id = values[0].map(v => v.id);
			// 	data._office_region_id = values[1].map(v => v.id);
			// 	console.log(data);

			// 	resolve(data);
			// });
		});
	}


}


// WEBPACK FOOTER //
// ./src/pages/teachers/detail/detail.ts